export default __webpack_public_path__ + "static/media/gps-icon.278ea035.svg";